module.exports = __webpack_public_path__ + "img/dianxin6-1.013bf1ee.png";